
import SummaryChosenSelectionCard from '@/components/SummaryChosenSelectionCard.vue';
import SummaryOfferCard from '@/components/SummaryOfferCard.vue';
import SummaryPrintView from '@/components/SummaryPrintView.vue';
import { JourneyPartType } from '@/models/journey-part-type';
import { Option } from '@/models/option';
import { PathSegment } from '@/models/path-segment';
import { startState } from '@/store';
import { Actions } from '@/store/actions';
import PriceUtil from '@/util/price-util';
import { computed, ComputedRef, defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'SummaryPathSegmentView',
  components: {
    SummaryOfferCard,
    SummaryChosenSelectionCard,
    SummaryPrintView
  },
  setup() {
    const store = useStore();

    /**
     * Returns the current calculated price, formatted for display, including currency
     */
    const calculatedPriceForDisplay: ComputedRef<string> = computed(() => {
      const calculatedPrice = store.state.calculatedPrice;
      return PriceUtil.formatGermanWithFractionsOptional(calculatedPrice);
    });

    /**
 * Returns the current calculated external price part, formatted for display, including currency
 */
    const calculatedExternalPricePartForDisplay: ComputedRef<string> = computed(() => {
      const calculatedExternalPricePart = store.state.calculatedExternalPricePart;
      return calculatedExternalPricePart > 0 ? PriceUtil.formatGermanWithFractionsOptional(calculatedExternalPricePart) : '';
    });

    /**
     * Returns the current calculated internal price part, formatted for display, including currency
     */
    const calculatedInternalPricePartForDisplay: ComputedRef<string> = computed(() => {
      const calculatedPrice = store.state.calculatedPrice;
      const calculatedExternalPricePart = store.state.calculatedExternalPricePart;

      return calculatedExternalPricePart > 0 ? PriceUtil.formatGermanWithFractionsOptional(calculatedPrice - calculatedExternalPricePart) : '';
    });


    /**
     * Returns an array containing the titles of all chosen segments
     */
    const chosenSegmentsTitles: ComputedRef<PathSegment[]> = computed(() => {
      return store.state.segmentLog.filter(
        (s: PathSegment) => s.dataObject?.type !== JourneyPartType.AdditionalOptions);
    });

    /**
     * Returns an array containing the names of all selected options
     */
    const chosenAdditionalOptions: ComputedRef<Option[]> = computed(() => {
      return store.state.options.filter((o: Option) => o.isSelected);
    });

    /**
     * Returns the morticians ad text to be displayed on the results page.
     **/
    const morticianAdText: ComputedRef<string> = computed(() => {
      return store.state.morticianSettings.adText;
    });

    /**
     * Returns the mortician name
     */
    const morticianName: ComputedRef<string> = computed(() => {
      return store.state.morticianSettings.name;
    });

    /**
     * Dispatches the reset action to reset the configurator to the start values
     */
    function resetConfigurator(): void {
      store.replaceState({ ...startState });
      store.dispatch(Actions.ResetAction);
    }

    return {
      calculatedPriceForDisplay,
      calculatedExternalPricePartForDisplay,
      calculatedInternalPricePartForDisplay,
      chosenSegmentsTitles,
      chosenAdditionalOptions,
      morticianAdText,
      morticianName,
      resetConfigurator
    };
  }
});
